import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchLanguageUpdate = createAsyncThunk(
    'languageUpdate/fetchLanguageUpdate',
    async ({ id, file, lang, code, zipCode }) => {
        const response = await LanguageUpdateService(id, file, lang, code, zipCode)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const languageUpdateSlice = createSlice({
    name: 'languageUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanguageUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLanguageUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLanguageUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default languageUpdateSlice.reducer;
